<template>
  <div class="relative" style="display: contents">
    <JoszakiButton
      v-bind="$attrs"
      ref="button"
      aria-describedby="dropdown"
      @click="onClick"
    >
      <slot />
    </JoszakiButton>
    <div
      ref="dropdown"
      role="listbox"
      class="hidden bg-white rounded-md border border-gray-300 z-10 shadow-md dark:bg-gray-800 dark:border-gray-600"
    >
      <slot name="header" />
      <component
        :is="item.component ?? 'div'"
        v-for="(item, index) in items"
        :key="index"
        :to="item.to"
        :href="item.href ?? item.to"
        :target="item.target"
        class="py-2 pl-3 pr-2 cursor-pointer hover:bg-primary-lightest text-sm text-black text-left whitespace-nowrap flex flex-row items-center dark:hover:bg-gray-700 dark:text-gray-100"
        :class="item.class"
        @click="onItemSelected(item)"
      >
        <slot v-if="$scopedSlots.item" name="item" :item="item" />
        <template v-else>
          <IconComponent
            v-if="checkboxes"
            class="inline w-5 h-5 mr-1 text-primary"
            :icon="item[isSelectedKey] ? 'check-square' : 'square'"
            :pack="item[isSelectedKey] ? 'fas' : 'far'"
          />
          <IconComponent
            v-if="item.icon"
            class="inline w-4 h-4 mr-1 text-primary"
            :icon="item.icon"
            :pack="item.iconPack"
            :class="item.iconClass"
          />
          {{ item[labelKey] }}
        </template>
      </component>
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import { createPopper } from "@popperjs/core";

export default {
  inheritAttrs: false,
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    checkboxes: {
      type: Boolean,
      default: false,
    },
    labelKey: {
      type: String,
      default: "label",
    },
    valueKey: {
      type: String,
      default: "value",
    },
    isSelectedKey: {
      type: String,
      default: "isSelected",
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      popper: null,
    };
  },
  mounted() {
    this.popper = createPopper(this.$refs.button.$el, this.$refs.dropdown, {
      placement: "bottom-end",
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 5],
          },
        },
      ],
    });

    document.addEventListener("click", this.outsideClickHandler);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.outsideClickHandler);
    if (this.popper) {
      this.popper.destroy();
    }
  },
  methods: {
    setEventListeners(enabled) {
      this.popper.setOptions((options) => ({
        ...options,
        modifiers: [...options.modifiers, { name: "eventListeners", enabled }],
      }));
    },
    showDropdown() {
      this.$refs.dropdown.classList.remove("hidden");
      this.$refs.dropdown.classList.add("block");

      this.setEventListeners(true);

      this.popper.update();
    },
    hideDropdown() {
      this.$refs.dropdown.classList.remove("block");
      this.$refs.dropdown.classList.add("hidden");

      this.setEventListeners(false);
    },
    toggleDropdown() {
      const isHidden = this.$refs.dropdown.classList.contains("hidden");
      if (isHidden) {
        this.showDropdown();
      } else {
        this.hideDropdown();
      }
    },
    onClick(e) {
      if (this.disabled || this.loading) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      this.toggleDropdown();
    },
    onItemSelected(item) {
      if (this.closeOnSelect) {
        this.hideDropdown();
      }
      this.$emit("itemSelected", item);
    },
    outsideClickHandler(e) {
      if (
        !this.$refs.button.$el.contains(e.target) &&
        !this.$refs.dropdown.contains(e.target)
      ) {
        this.hideDropdown();
      }
    },
  },
};
</script>
